import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import { useTeamPhotos } from '../context/TeamPhotosContext';
import { pathForGoTo } from '../lib/siteRoutes';

export default function PracticeAreaTemplate({ pa }) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { photoFor } = useTeamPhotos();

  const goPage = (page) => {
    navigate(pathForGoTo(page));
  };

  return (
    <div className="page">
      <section className="page-hero">
        <div className="hero-bg"></div>
        <div className="hero-accent"></div>
        <div className="hero-inner">
          <div className="hero-eyebrow">
            <div className="eyebrow-line"></div>
            <span className="eyebrow-text">{pa.eyebrow}</span>
          </div>
          <h1 className="page-hero-title">
            {pa.titleFirst}{pa.titleFirst && pa.titleEm ? ' ' : ''}{pa.titleEm && <em>{pa.titleEm}</em>}
          </h1>
          <p className="page-hero-sub">{pa.sub}</p>
          <div className="hero-tags" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', animation: 'fadeUp .9s .75s both' }}>
            {pa.tags.map((tag) => (
              <span key={tag} className="pap-hero-tag">{tag}</span>
            ))}
          </div>
        </div>
      </section>

      <div className="pap-content">

        <div className="pap-section reveal">
          <div className="pap-eyebrow"><div className="pap-line"></div><span className="pap-tag">{t('shared.howWeCanHelp')}</span></div>
          <h2 className="pap-title">{t('shared.ourServices')}</h2>
          <div className="svc-grid">
            {pa.services.map((s, i) => (
              <div key={i} className="svc-card">
                <div className="svc-name">{s.name}</div>
                <div className="svc-desc">{s.desc}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="pap-section reveal">
          <div className="pap-eyebrow"><div className="pap-line"></div><span className="pap-tag">{t('shared.trackRecord')}</span></div>
          <h2 className="pap-title">{t('shared.notableEngagements')}</h2>
          <p className="pap-sub">{t('shared.engagementsSub')}</p>
          <div className="eng-list">
            {pa.engagements.map((e, i) => (
              <div key={i} className="eng-item">
                <div className="eng-left">
                  <div className="eng-num">{e.num}</div>
                  <div className="eng-tag">{e.tag}</div>
                </div>
                <div className="eng-divider"></div>
                <div><p className="eng-text">{e.text}</p></div>
              </div>
            ))}
          </div>
        </div>

        <div className="pap-section reveal">
          <div className="pap-eyebrow"><div className="pap-line"></div><span className="pap-tag">{t('shared.whyDilinh')}</span></div>
          <h2 className="pap-title">{t('shared.whyChoose')}</h2>
          <div className="why-grid">
            {pa.why.map((w, i) => (
              <div key={i} className="why-card">
                <div className="why-num">{w.num}</div>
                <div className="why-title">{w.title}</div>
                <div className="why-desc">{w.desc}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="pap-section reveal">
          <div className="pap-eyebrow"><div className="pap-line"></div><span className="pap-tag">{t('shared.sectors')}</span></div>
          <h2 className="pap-title">{t('shared.industriesWeServe')}</h2>
          <div className="ind-chips">
            {pa.industries.map((ind, i) => (
              <div key={i} className="ind-chip">{ind}</div>
            ))}
          </div>
        </div>

        <div className="pap-section reveal">
          <div className="pap-eyebrow"><div className="pap-line"></div><span className="pap-tag">{t('shared.yourTeam')}</span></div>
          <h2 className="pap-title">{t('shared.whoWillAdvise')}</h2>
          <div className="team-strip-2">
            {pa.team.map((m) => {
              const src = photoFor(m.slug);
              return (
              <div key={m.slug} className="team-mini">
                <div className="tmi-avatar" style={{ overflow: 'hidden', padding: 0 }}>
                  {src && (
                    <img src={src} alt={m.name} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top' }} />
                  )}
                </div>
                <div>
                  <div className="tmi-name tmi-name-link" onClick={() => goPage('profile-' + m.slug)}>{m.name}</div>
                  <div className="tmi-title">{m.title}</div>
                </div>
              </div>
            );
            })}
          </div>
        </div>

        <div className="pap-section reveal">
          <div className="pap-eyebrow"><div className="pap-line"></div><span className="pap-tag">{t('shared.alsoConsider')}</span></div>
          <h2 className="pap-title">{t('shared.relatedPracticeAreas')}</h2>
          <div className="rel-grid">
            {pa.related.map((r) => (
              <div key={r.slug} className="rel-card reveal" onClick={() => goPage('pa-' + r.slug)}>
                <div className="rel-name">{r.name}</div>
                <div className="rel-desc">{r.desc}</div>
                <button className="rel-link" type="button" onClick={(e) => { e.stopPropagation(); goPage('pa-' + r.slug); }}>{t('shared.learnMore')}</button>
              </div>
            ))}
          </div>
        </div>

      </div>

      <div className="pap-cta-band reveal">
        <div>
          <h2>{pa.cta.titlePre}<br /><em>{pa.cta.titleEm}</em></h2>
          <p>{pa.cta.sub}</p>
        </div>
        <div className="pap-cta-btns">
          {pa.cta.btns.map((b, i) => (
            <button key={i} type="button" className={b.cls} onClick={() => goPage(b.page)}>
              {b.text === 'Contact Our Team' ? t('shared.contactTeam') : b.text === 'Meet the Partners' ? t('shared.meetPartners') : b.text === 'View Document Toolkits' ? t('buttons.exploreToolkits') : b.text}
            </button>
          ))}
        </div>
      </div>

      <Footer variant="full" firmColumn="team" />
    </div>
  );
}
